<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5vwenC/images/e9781439633854_cover.jpg?1700070684354" alt="This image is the cover for the book Vinalhaven Island, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vinalhaven Island, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>With over 200 historic images, Vinalhaven Island is sure to inform and entertain.</b></p><br/><p>Located in Penobscot Bay, Vinalhaven Island is a land mass about 10 by 5 miles, with the town situated on Carvers' Harbor, 15 miles from the mainland. Always a working community, Vinalhaven presently serves as one of the largest lobstering centers in the world. Islanders, summer residents, visitors, and other interested persons on the mainland and elsewhere are invited to partake of this striking photographic record of the island as it was between 1860 and 1960. Contained within are classic views that bring to life the island's ongoing fishing and granite industries. Some show the enormous columns for the Cathedral of St. John the Divine in New York City being cut and polished; others document the carving of the eagles for the Buffalo, NY, Post Office. Lesser-known occupations are portrayed as well, like the making of horse nets, which employed many women. Readers are given the rare opportunity to meet such people as granite company operator Moses Webster; Joseph Bodwell (a Maine governor); Edward Russell (from Ireland) and Joseph Black (from Scotland); and O. P. Lyons, founder of the first local newspaper and band. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vinalhaven Historical Society
      </h2>
      
      <p class="authorDescription body article">Over 200 historic images are presented here, drawn mainly from the collection of the Vinalhaven Historical Society. The majority of images come from glass plate originals taken by William H. Merrithew between 1890 and 1930, but also included are the works of native photographers Charles Vinal (1870s), William Vinal Lane (1880s), and Frank H. Winslow (early 1900s). The resulting collection is sure to inform and entertain.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?533caf9a